import React from 'react';
import { BrowserRouter, Route, Switch } from  'react-router-dom';

import SignUpScreen from '../components/SignUpScreen/index.js';
import Filter from '../components/Filter/index.js';
import Fashion from '../components/Categories/Fashion/index.js';
import Politics from '../components/Categories/Politics/index.js';
import Science from '../components/Categories/Science/index.js';
import Tech from '../components/Categories/Tech/index.js';
import Home from '../components/Categories/Home/index.js';
import Error from '../components/Error/index.js';

const AppRouter = () => (
    <BrowserRouter>
        <Switch>
            <Route path="/" component={SignUpScreen} exact/>
            <Route path="/search" component={Filter} exact/>
            <Route path="/section/fashion" component={Fashion} exact/>
            <Route path="/section/politics" component={Politics} exact/>
            <Route path="/section/science" component={Science} exact/>
            <Route path="/section/tech" component={Tech} exact/>
            <Route path="/home" component={Home} exact/>
            <Route component={Error} />
        </Switch>
        
    </BrowserRouter>
);

export default AppRouter;